import AttendanceAdapter from './base';

export default class Expulsion extends AttendanceAdapter {
  modelNamePlural = 'expulsions';
}
